import { useState, useCallback, useEffect } from "react";
import styles from "./PhoneCarousel.module.css";

interface PhoneCarouselProps {
  images: { src: string; alt: string }[];
  accentColor?: string;
}

export default function PhoneCarousel({
  images,
  accentColor = "#00F0FF",
}: PhoneCarouselProps) {
  const [active, setActive] = useState(0);
  const total = images.length;

  const next = useCallback(
    () => setActive((i) => (i + 1) % total),
    [total]
  );
  const prev = useCallback(
    () => setActive((i) => (i - 1 + total) % total),
    [total]
  );

  /* auto-advance every 4s, pause on hover handled via CSS */
  useEffect(() => {
    const id = setInterval(next, 4000);
    return () => clearInterval(id);
  }, [next]);

  return (
    <div
      className={styles.wrapper}
      style={{ "--accent": accentColor } as React.CSSProperties}
    >
      {/* Phone frame */}
      <div className={styles.phone}>
        <div className={styles.notch} />
        <div className={styles.screen}>
          {images.map((img, i) => (
            <div
              key={img.src}
              className={`${styles.slide} ${i === active ? styles.slideActive : ""}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Controls */}
      <div className={styles.controls}>
        <button
          className={styles.arrow}
          onClick={prev}
          aria-label="Previous screenshot"
        >
          ‹
        </button>
        <div className={styles.dots}>
          {images.map((_, i) => (
            <button
              key={i}
              className={`${styles.dot} ${i === active ? styles.dotActive : ""}`}
              onClick={() => setActive(i)}
              aria-label={`Go to screenshot ${i + 1}`}
            />
          ))}
        </div>
        <button
          className={styles.arrow}
          onClick={next}
          aria-label="Next screenshot"
        >
          ›
        </button>
      </div>
    </div>
  );
}
